import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import useApi from "$src/core/hooks/use-api";
import type { SubscriptionDto } from "$src/core/models/dto";

export const queryKey = () => ["subscription"];

const useSubscriptionQuery = (
  options?: Omit<
    UseQueryOptions<Awaited<SubscriptionDto | null>>,
    "queryKey" | "queryFn"
  >,
) => {
  const { api } = useApi();

  return useQuery({
    queryKey: queryKey(),
    queryFn: () => api.getSubscription(),
    ...options,
  });
};

export default useSubscriptionQuery;
